import React from "react";
import { Button } from "semantic-ui-react";
import ShareButton from "../../ShareButton";
import { getCampaignSharingUrl } from "../../../util";
import { currentWindowUrl } from "../../../util/windowLocation";

function LinkedInShareButton({ customUrl, post, campaignName, eventSource, children }) {
  const sharingUrl = customUrl || currentWindowUrl;
  const platformUrl = "https://www.linkedin.com/shareArticle";

  const campaignSharingUrl = getCampaignSharingUrl("linkedIn", sharingUrl, campaignName);

  const linkedInOptions = {
    url: campaignSharingUrl,
    mini: true,
    title: post ? post.title : "",
    source: "Casemasters",
  };

  return (
    <ShareButton
      platformUrl={platformUrl}
      platformOptions={linkedInOptions}
      platformName="linkedin"
      postUrl={sharingUrl}
      eventSource={eventSource}
    >
      {children ? children : <Button circular color="linkedin" icon="linkedin" />}
    </ShareButton>
  );
}

export default LinkedInShareButton;



// WEBPACK FOOTER //
// ./src/components/SharingButtons/LinkedInShareButton/index.js